interface Toastmessageparams {
    message: string;
    icon?: toasterIcons | string;
    options?: toastOptions;
    ID?: string
}

enum toasterIcons {
    warning = "fas fa-exclamation-triangle w3-text-orange",
    notification = "fas fa-exclamation-circle secondary",
    error = "fas fa-times-circle w3-text-red",
    confirmCheck = "fas fa-check w3-text-green",
    question = "fas fa-question w3-text-orange",
    info = "fas fa-info-circle w3-text-blue",
    close = "fas fa-times",
    save = "fas fa-save",
    undo = "fas fa-undo",
    redo = "fas fa-redo",
    hourglass = "fas fa-hourglass-half",
    hourglassStart = "fas fa-hourglass-start",
    hourglassEnd = "fas fa-hourglass-end ",
    delete = "fas fa-trash",
    forbidden = "fas fa-ban w3-text-red",
    none = ""
    
}

(globalThis as any).toasterIcons = toasterIcons; // (mds A11) seed runtime value for cross-file bare refs

interface toastOptions {
    timeout?: number | "permanent";
    hideTimeoutProgress?: boolean;
    closeButton?: boolean;
    ID?: string;
    buttons?: Array<toastButton>;
    onClick?: Function | { callback: Function };
}

interface toastButton {
    label: string,
    callback: Function,
    icon?: toasterIcons | string;
}

interface GlobalToastConfig {
    title: string | HTMLElement,
    iconClass?: toasterIcons | string,
    message?: string,
    messageIcon?: string,
    options?: toastOptions
    timeout?: number | "permanent",
    ID?: string
    showClose?: boolean,
    modalSize?: "larger" |"smaller" | "fullsize"
}
